import {supabase} from "../utils/supabaseClient";
import {MatchEventsInterface} from "../utils/types";

const getMatchEvents = async(period2matchIds: number[]): Promise<MatchEventsInterface[]> =>  {
    try {
        const { data, error } = await supabase
            .from('match_events')
            .select(`
                id,
                time, 
                fk_parent,
                fk_period2match: period2match!match_events_fk_period2match_fkey (
                    fk_period: match_periods!period2match_fk_period_fkey (
                        id,
                        period
                    )
                ),
                fk_event_type: match_event_types!match_events_fk_event_type_fkey (
                    event_type,
                    icon
                ),
                fk_persona:personas!match_events_fk_persona_fkey (
                    id,
                    first_name,
                    last_name,
                    nick_name,
                    team: persona2team (
                        fk_team
                    )
                )
            `)
            .in('fk_period2match', period2matchIds)

        if (error) {
            console.error('Match Events Error:', error);
            throw error;
        }

        // Определим тип для fk_period2match
        type Period2Match = {
            fk_period?: { id: number; period: string } | { id: number; period: string }[];
        };

        // Преобразуем все нужные поля в массивы
        const processedData = data.map(event => ({
            ...event,
            fk_persona: Array.isArray(event.fk_persona) ? event.fk_persona : [event.fk_persona].filter(Boolean),
            fk_event_type: Array.isArray(event.fk_event_type) ? event.fk_event_type : [event.fk_event_type].filter(Boolean),
            fk_period2match: Array.isArray(event.fk_period2match)
                ? event.fk_period2match.map((p2m: Period2Match) => ({
                    ...p2m,
                    fk_period: Array.isArray(p2m.fk_period) ? p2m.fk_period : [p2m.fk_period].filter(Boolean)
                }))
                : [(event.fk_period2match as Period2Match)].filter(Boolean).map((p2m: Period2Match) => ({
                    ...p2m,
                    fk_period: Array.isArray(p2m.fk_period) ? p2m.fk_period : [p2m.fk_period].filter(Boolean)
                }))
        }));

        console.log('Match events:', processedData);

        return processedData as MatchEventsInterface[];
    } catch(error) {
        console.error('Error fetching match events:', error);
        throw error;
    }
}

export default getMatchEvents;